import { FC } from "react";
import st from './advantageCard.module.scss';
import cn from "classnames";

interface AdvantageCardProps {
    number: string
    text: string
    filled?: boolean
}

const AdvantageCard: FC<AdvantageCardProps> = ({number, text, filled}) => {
    return (
        <div className={cn(st['advantage-card'], filled && st['advantage-card--filled'])}>
            <span className={st['advantage-card__number']}>{number}</span>
            <p className={st['advantage-card__text']}>{text}</p>
        </div>
    );
};

export default AdvantageCard;